import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CbDialogModule} from '@app/shared/components/dialog/dialog.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CbFormsModule} from '@app/shared/components/forms/forms.module';
import {DesignComplexityDialogComponent} from './design-complexity-dialog/design-complexity-dialog.component';
import {CbHubTableModule} from '@app/shared/components/table/table.module';
import {CbInfoMessageModule, CbLoadingSpinnerModule, CbTableModule} from 'cb-hub-lib';
import {DesignWorkflowComponent} from './design-workflow/design-workflow.component';
import {DefaultSystemAreaDocumentsComponent} from './default-system-area-documents/default-system-area-documents.component';
import {DesignComplexityComponent} from './design-complexity/design-complexity.component';
import {MatTabsModule} from '@angular/material/tabs';
import {DesignSchemeNotificationsComponent} from './design-scheme-notifications/design-scheme-notifications.component';
import {DesignSchemeNotificationsDialogComponent} from './design-scheme-notifications-dialog/design-scheme-notifications-dialog.component';

@NgModule({
    declarations: [
        DesignComplexityComponent,
        DesignComplexityDialogComponent,
        DesignWorkflowComponent,
        DefaultSystemAreaDocumentsComponent,
        DesignSchemeNotificationsComponent,
        DesignSchemeNotificationsDialogComponent
    ],
    imports: [
        CommonModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        CbDialogModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatInputModule,
        MatTableModule,
        CbInfoMessageModule,
        CbLoadingSpinnerModule,
        CbFormsModule,
        CbHubTableModule,
        CbTableModule,
        MatTabsModule,
    ],
    exports: [
        DesignWorkflowComponent
    ]
})
export class DesignWorkflowSettingsModule { }
